import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * shadcn/ui canonical class-name helper. Combines clsx (conditional
 * classes) with tailwind-merge (deduplicates conflicting Tailwind
 * utilities, e.g. "px-2 px-4" → "px-4").
 */
export function cn(...inputs: ClassValue[]): string {
  return twMerge(clsx(inputs));
}
